import { ActionIcon, Textarea } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';

const PromptInput = ({ promptAddition, setPromptAddition, onSubmit, disabled, setInputTooLong, maxTokens }) => {
  const textAreaRef = useRef(null);
  const [prompt, setPrompt] = useState('');

  useEffect(() => {
    if (!promptAddition) {
      return;
    }

    setPrompt((prev) => `${prev}${promptAddition}`);

    setPromptAddition('');
  }, [promptAddition, setPromptAddition]);

  const handleEnterClick = (e) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (disabled) {
      return;
    }

    onSubmit(prompt);
    setPrompt('');
  };

  const handleSetPrompt = (prompt) => {
    setPrompt(prompt);

    const charCount = prompt.length;
    const tokenCount = charCount / 4;
    setInputTooLong(tokenCount > maxTokens);
  };

  return (
    <>
      <Textarea
        ref={textAreaRef}
        value={prompt}
        placeholder="Type your message..."
        minRows={1}
        maxRows={10}
        autosize
        onKeyDown={handleEnterClick}
        onChange={(e) => handleSetPrompt(e.target.value)}
        styles={{
          input: {
            border: 'none',
            backgroundColor: 'transparent',
            '&:focus': {
              border: 'none',
            },
          },
        }}
        rightSection={
          <ActionIcon
            variant="filled"
            color="primary"
            onClick={handleSubmit}
            disabled={disabled || !prompt.trim()}
            radius="sm"
          >
            <IconSend size={18} />
          </ActionIcon>
        }
        rightSectionWidth={42}
      />
    </>
  );
};

export default PromptInput;
